import { useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSnackbar } from 'notistack';

import Dialog from 'src/componentes/dialog';
import Input from 'src/componentes/input';
import Button from 'src/componentes/button';
import IconsHoverSelect from 'src/componentes/IconsHoverSelect';
import LoadingContainer from 'src/componentes/loading-container';
import errorHandler from 'src/utils/error-handler';
import { getSession } from 'src/contexts/AuthContext';
import { ACAO_INTERACAO_FEEDBACK } from 'src/utils/constants';
import http from 'src/services/httpService';
import { capitalizeFirstLetter } from 'src/utils/string';

const FeedbackSophie = ({
  requestId,
  interactionType,
  preSelectedRating = null,
  ...rest
}) => {
  const intl = useIntl();
  const ref = useRef();

  const [rating, setRating] = useState(preSelectedRating || {});
  const [comment, setComment] = useState('');
  const [disabled, setDisabled] = useState(!preSelectedRating);
  const [isLoading, setIsLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const saveFeedbackAcess = async (acaoInteracaoFeedbackId) => {
    setIsLoading(true);
    try {
      http.post(`/FeedbackActioIA/SalvarAcessoFeedbackRedis`, {
        interactionType,
        acaoInteracaoFeedbackId,
      });

      setIsLoading(false);
    } catch (err) {
      errorHandler(err, intl);
    }
  };

  const handleClose = () => {
    saveFeedbackAcess(ACAO_INTERACAO_FEEDBACK.FECHAR);
    if (ref.current) ref.current.close();
  };

  const handleEvaluateLater = () => {
    saveFeedbackAcess(ACAO_INTERACAO_FEEDBACK.AVALIAR_DEPOIS);
    if (ref.current) ref.current.close();
  };

  const handleSaveFeedback = async () => {
    setIsLoading(true);
    const { accessToken } = getSession();

    try {
      await fetch(process.env.REACT_APP_API_OPENAI + '/api/open-ai/feedback', {
        method: 'POST',
        body: JSON.stringify({
          requestId,
          interactionType,
          rating: rating.id,
          comment,
        }),
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setIsLoading(false);

      handleClose();

      enqueueSnackbar(intl.formatMessage({ id: 'feedbackEnviado' }), {
        variant: 'success',
      });
    } catch (err) {
      setIsLoading(false);
      errorHandler(err);
    }
  };

  const handleSetRating = (value) => {
    setRating(value);
    setDisabled(false);
  };

  return (
    <Dialog
      ref={ref}
      width={500}
      height={550}
      onRequestClose={handleClose}
      mouseDownClose={true}
      respeitarAltura
      {...rest}
    >
      <LoadingContainer isLoading={isLoading}>
        <div className="d-flex flex-column align-items-center justify-content-center px-5">
          <div className="font-weight-bolder mb-4 text-left text-xl">
            {intl.formatMessage({ id: 'feedbackSophie' })}
          </div>

          <div className={`text-left mb-2`}>
            {intl.formatMessage({ id: 'compartilheSeuFeedback' })}
          </div>

          <div className="d-flex mt-4 mb-4 w-100">
            <IconsHoverSelect
              icon="star"
              iconSize={26}
              iconColor={'#FDCC0D'}
              onClick={(value) => handleSetRating(value)}
              value={rating ? { id: rating.id } : null}
              itens={[{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }]}
            />
          </div>

          <Input
            className="mt-2"
            showLabel
            formStyle={{ width: '100%' }}
            style={{ padding: 25 }}
            type="textarea"
            rows={2}
            maxLength={1000}
            model={{
              label: intl.formatMessage({ id: 'inserirComentario' }),
              value: comment,
              requestChange: (value) => setComment(value),
            }}
          />

          <div className="d-flex justify-content-between align-items-center mt-4 mb-5 w-100">
            <a href="#" onClick={handleEvaluateLater}>
              {capitalizeFirstLetter(
                intl.formatMessage({ id: 'label.avaliarDepois' })
              )}
            </a>

            <div className="d-flex" style={{ gap: '8px' }}>
              <Button color="secondary" leftIcon="close" onClick={handleClose}>
                {intl.formatMessage({ id: 'label.cancelar' })}
              </Button>

              <Button
                disabled={disabled || isLoading}
                leftIcon="content-save-outline"
                onClick={handleSaveFeedback}
              >
                {intl.formatMessage({ id: 'darFeedback' })}
              </Button>
            </div>
          </div>
        </div>
      </LoadingContainer>
    </Dialog>
  );
};

export default FeedbackSophie;
